/* unplugin-vue-components disabled */import { render } from "./index.vue?vue&type=template&id=6a086cef&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=6a086cef&lang=css&scoped=true"

import exportComponent from "F:\\vue2.0+ vant\\2024年项目集合\\元羿官网项目集合\\元羿中文版本\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a086cef"]])

export default __exports__